// Considered: none — inspector-specific composition of ButtonAtom + a mono address strip.
// See spec Reuse Audit (specs/stream-trajectory-tools.md).
//
// Source: design/metaspace-tools/metaspace-interactions.jsx:85-90.

import React, { useState } from 'react';
import { useTranslation } from 'localization';
import ButtonAtom from '../../atoms/Button/ButtonAtom';
import './AddressRowMolecule.scss';

export interface AddressRowMoleculeProps {
  /** The canonical URL for this detail. Copy link copies this, unmodified. */
  address: string;
  /** Called after the address is copied to the clipboard. */
  onCopy?: (address: string) => void;
  className?: string;
}

const CONFIRMATION_MS = 2000;

const AddressRowMolecule: React.FC<AddressRowMoleculeProps> = ({ address, onCopy, className }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard.writeText(address).then(() => {
      setCopied(true);
      onCopy?.(address);
      setTimeout(() => setCopied(false), CONFIRMATION_MS);
    });
  };

  return (
    <div className={['address-row-molecule', className].filter(Boolean).join(' ')}>
      <span className="address-row-molecule__address" title={address}>
        {address}
      </span>
      <ButtonAtom
        shape="pill"
        variant="secondary"
        size="small"
        icon="pi pi-link"
        label={copied ? t('toolInspector.addressRow.copied') : t('toolInspector.addressRow.copyLink')}
        onClick={handleCopy}
      />
    </div>
  );
};

AddressRowMolecule.displayName = 'AddressRowMolecule';

export default AddressRowMolecule;
